import script from "./DashboardActivitiesWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardActivitiesWidget.vue?vue&type=script&setup=true&lang=js"

import "./DashboardActivitiesWidget.vue?vue&type=style&index=0&id=0fe3a2cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe3a2cd"]])

export default __exports__